import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import db from "./firebase";
import VideoCommentContent from "./Videocommentcontent";

const VideoCommentsDisplay = ({videoTitle,documentRef}) => {
    const [comment,setComment]= useState([]);
    const[erralert,setAlert]  = useState(false) ;

    useEffect(()=>{
        const collectionref = collection(db,"Video Comments");
        const q = query(collectionref,where("message_title","==",videoTitle),orderBy("timestamp","desc"));
        if(collectionref){
            try{
                const unsub = onSnapshot(q,(snapshot)=>{
                    const documents = [];
                    snapshot.forEach((doc)=>{
                        documents.push(doc.data());
                    });
                    setComment(documents);
                });
                return unsub;
            }catch(error){
                console.log(error);
                setAlert(true);
            }
        }
    },[videoTitle]);


    return ( 
        <div className="vidcommentsdisplay">
            {erralert && <h3>Unable to fetch comments from server. If error persist report to the HBR Team.</h3>}
            {comment && comment.map(data => (
                 <VideoCommentContent
                    key={data.timestamp}
                    dataSent ={data.date_sent}
                    user_name ={data.userName}
                    commentText={data.comment}
                    timestamp={data.timestamp}
                    useremail = {data.user_email}
                 />
            ))}
           
        </div>
     );
}
export default VideoCommentsDisplay;